import { styled } from 'styled-system/jsx'

const IframeShell = styled('div', {
  base: {
    width: '100%',
    height: '100%',
    minHeight: '480px',
    border: 'none',
    borderRadius: 'md',
    overflow: 'hidden',
    backgroundColor: 'app.surface',
    position: 'relative',
  },
})

const IframeElement = styled('iframe', {
  base: {
    width: '100%',
    minHeight: '480px',
    height: '100%',
    border: 'none',
    display: 'block',
  },
})

const IframeOverlay = styled('div', {
  base: {
    position: 'absolute',
    inset: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'app.surface',
    fontFamily: 'body',
    fontSize: '14px',
    color: 'app.fgMuted',
  },
})

export { IframeShell, IframeElement, IframeOverlay }
